module.exports = __webpack_public_path__ + "img/emailicon.0ce00c6a.svg";